module.exports = __webpack_public_path__ + "media/src/assets/images/profile-img-ba4e037e1b9676c5215541748eaa1e42.png";